export class Controller {
  constructor() {
    this.thisHTML = document.querySelector('html');
    this.form = document.querySelector('#toggle-dark-mode');
    
    if (!this.form) {
      return;
    }

    this.trigger = this.form.querySelector('#enable-dark-mode');
    this.triggerInput = this.form.querySelector('.input-toggle-checkbox');
    this.triggerSwitch = this.form.querySelector('.input-toggle-switch');
  }

  isModeDefined() {
    return localStorage.getItem('theme') || false;
  }

  enable() {
    this.triggerInput && this.triggerInput.classList.add('is-checked');
    this.thisHTML.setAttribute('data-theme', 'dark');
    localStorage.setItem('theme', 'dark');
  }

  disable() {
    this.triggerInput && this.triggerInput.classList.remove('is-checked');
    this.thisHTML.setAttribute('data-theme', 'light');
    localStorage.setItem('theme', 'light');
  }

  setLocalStorage() {
    const thisHTML = document.querySelector('html');
    localStorage.setItem('theme', thisHTML.getAttribute('data-theme'));
  }

}